import React from 'react';

interface ProfileData {
  fullName: string;
  phone: string;
  profileImage: File | null;
  profileImageUrl?: string;
  businessName: string;
  licenseNumber: string;
  yearsOfExperience: number;
  bio: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  website: string;
  specialties: string[];
  services: string[];
  treatmentCategories: string[];
  pricingRange: string;
  virtualConsultations: boolean;
  education: Array<{
    degree: string[];
    institution: string;
    year: string;
  }>;
  certifications: Array<{
    name: string[];
    issuer: string;
    year: string;
  }>;
  affiliations: string[];
  insuranceAccepted: string[];
  languagesSpoken: string[];
}

interface Step2ProfessionalProps {
  data: ProfileData;
  updateData: (updates: Partial<ProfileData>) => void;
}

const Step2Professional: React.FC<Step2ProfessionalProps> = ({ data, updateData }) => {
  return (
    <div className="space-y-4 sm:space-y-6">
      <h2 className="font-['Ovo',_serif] text-[22px] sm:text-[26px] lg:text-[28px] text-[#1f1f1f] mb-4 sm:mb-6">
        Tell us about your professional background
      </h2>

      <div>
        <label className="block mb-2 font-['Open_Sans'] text-sm font-semibold text-[#1f1f1f]">
          Business Name *
        </label>
        <input
          type="text"
          value={data.businessName}
          onChange={(e) => updateData({ businessName: e.target.value })}
          className="w-full px-4 py-3 sm:py-2.5 border border-[#e5e5ea] rounded focus:outline-none focus:border-[#c6a664] text-base"
          placeholder="Your practice or business name"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
        <div>
          <label className="block mb-2 font-['Open_Sans'] text-sm font-semibold text-[#1f1f1f]">
            License Number
          </label>
          <input
            type="text"
            value={data.licenseNumber}
            onChange={(e) => updateData({ licenseNumber: e.target.value })}
            className="w-full px-4 py-3 sm:py-2.5 border border-[#e5e5ea] rounded focus:outline-none focus:border-[#c6a664] text-base"
            placeholder="Professional license number"
          />
        </div>

        <div>
          <label className="block mb-2 font-['Open_Sans'] text-sm font-semibold text-[#1f1f1f]">
            Years of Experience *
          </label>
          <input
            type="number"
            value={data.yearsOfExperience}
            onChange={(e) => updateData({ yearsOfExperience: parseInt(e.target.value) || 0 })}
            className="w-full px-4 py-3 sm:py-2.5 border border-[#e5e5ea] rounded focus:outline-none focus:border-[#c6a664] text-base"
            placeholder="0"
            min="0"
          />
        </div>
      </div>

      <div>
        <label className="block mb-2 font-['Open_Sans'] text-sm font-semibold text-[#1f1f1f]">
          Professional Bio <span className="text-[#767472] font-normal">(optional)</span>
        </label>
        <textarea
          value={data.bio}
          onChange={(e) => updateData({ bio: e.target.value })}
          className="w-full px-4 py-3 sm:py-2.5 border border-[#e5e5ea] rounded focus:outline-none focus:border-[#c6a664] h-32 text-base"
          placeholder="Tell potential clients about your expertise, approach, and what makes you unique..."
        />
        <p className="mt-2 text-xs text-[#767472]">{data.bio.length}/500 characters</p>
      </div>
    </div>
  );
};

export default Step2Professional;
